import React from "react";
import { Goals } from "../../components/TeamDetail/Goals";
import { NumberFormat } from "../../Common/NumberFormat";
import {LetestTimer} from "./latestTimer";

export const GoalTimerRoot = ({ details, donation, sign , showLatestUi}) => {
  const timeRemaining = new Date(details.campaignEndTime) - new Date();
  const bonusEnd = new Date(details.bonusGoalEndDate) - new Date();
  const bonus = donation > parseInt(details.goalAmount) && timeRemaining <= 0
  let currency='USD';
  if(details.campaignCurrency)
  {
    currency = details.campaignCurrency ? details.campaignCurrency.toUpperCase() : details.currency[0].code.toUpperCase();
  }
  
  return (
    <section className="goals">
      {(timeRemaining <= 0 && bonusEnd <= 0 && bonus) || (timeRemaining <= 0 && !bonus) ? (
        <div className="bouns_goal_div text-center">
          <img height="200px" src="/images/successful.png" alt="Success" />
        </div>
      ) : (
          (Object.keys(details).length) && (!details.enableNoTimeCampaign) ? <LetestTimer
          startTime={details.campaignStartTime}
          endTime={details.campaignEndTime}
          bonus={bonus}
          bonusEnd={details.bonusGoalEndDate}
          showLatestUi={showLatestUi}
        /> : null
        )}
      {/* {(timeRemaining >=0 )&& (donation > parseInt(details.goalAmount)) && details.bonusGoalAmount1 && ( */}
      
      {/* {(donation > parseInt(details.goalAmount)) && details.bonusGoalAmount1 && (
        <p className="bouns-goal-point text-center">
          <strong>New GOAL {sign}{NumberFormat(details.bonusGoalAmount1)}</strong>{" "}
          {currency}
        </p>
      )}
      <p className="goal-point goal-point-bouns text-center">
        <strong className={bonus && "check"}>
          GOAL {sign}{NumberFormat(details.goalAmount)}
        </strong>{" "}
        {currency}
      </p> */}
    </section>
  );
};
